import { ShieldCheck, Mic2, MapPin, FileText } from 'lucide-react';

const trustItems = [
  { icon: ShieldCheck, title: '实名可信', description: '身份核验，安全保障' },
  { icon: Mic2, title: '声纹打卡', description: '声纹识别，防代打卡' },
  { icon: MapPin, title: '定位到岗', description: 'GPS定位，确保到岗' },
  { icon: FileText, title: '证据留痕', description: '全程记录，可追溯' },
];

export function TrustStrip() {
  return (
    <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
      {trustItems.map((item) => {
        const Icon = item.icon;
        return (
          <div key={item.title} className="rounded-xl bg-white/60 p-4 text-center shadow-sm backdrop-blur-sm">
            <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-50 to-teal-50">
              <Icon className="h-5 w-5 text-emerald-600" />
            </div>
            <div className="mt-2 font-bold text-sm text-slate-900">{item.title}</div>
            <div className="mt-1 text-xs text-slate-500">{item.description}</div>
          </div>
        );
      })}
    </div>
  );
}
